module.exports = __webpack_public_path__ + "img/cp-02.e608f310.png";